import { c as _c } from "react/compiler-runtime";
/* eslint-disable */
import { useEffect, useState, useCallback } from "react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useEcomStore } from "@/context/ecom/EcomContext";
import { useLogin } from "@/context/login/LoginContext";
import { refreshAuthToken } from "@/lib/refreshAuthToken";
import { accountsEndpoint } from "@/lib/config/environments";
import { safeSlug } from "@/lib/utils";
import { env, myProfileBaseUrl, accountsBaseUrl, productsLink } from "@/lib/config/environments";
const formatLink = link => {
  // SimpleLink or ExternalLink
  if (link?.url) {
    return {
      text: link?.text,
      url: link?.url
    };
    // PageGeneral
  } else if (link?.slug) {
    return {
      text: link?.text,
      url: `/${safeSlug(link?.slug)}`,
      Link: Link
    };
    // SimpleLink with reference
  } else if (link?.reference?.slug) {
    return {
      text: link?.text,
      url: `/${safeSlug(link?.reference?.slug)}`,
      Link: Link
    };
  }
  return null;
};
const useFlyout = (flyoutData, isLoginDisabled, locale, isAuthenticated, user, handleLogout, path, query, signUpQuery, ecommerceSettings, redirect_uri, code_verifier, client_id, url) => {
  const $ = _c(208);
  const router = useRouter();
  const pathname = usePathname();
  const [state, dispatch] = useEcomStore() ?? [];
  const loginCtx = useLogin();
  let t0;
  if ($[0] !== loginCtx) {
    t0 = loginCtx ?? [];
    $[0] = loginCtx;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [loginState, loginDispatch] = t0;
  let t1;
  if ($[2] !== loginDispatch) {
    t1 = (token, authTime, idToken, refreshToken) => {
      loginDispatch?.({
        type: "SET_LOGIN",
        payload: {
          token,
          authTime,
          idToken,
          refreshToken
        }
      });
    };
    $[2] = loginDispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onLogin = t1;
  let t2;
  if ($[4] !== loginDispatch) {
    t2 = () => {
      loginDispatch?.({
        type: "LOG_OUT"
      });
    };
    $[4] = loginDispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onLogout = t2;
  const [flyoutAccounts, setFlyoutAccounts] = useState(undefined);
  const [isAccountSwitcherOpen, setAccountSwitcherOpen] = useState(false);
  const [isOwnerAccount, setOwnerAccount] = useState(false);
  const [isAdminAccount, setAdminAccount] = useState(false);
  const [isDx, setDx] = useState(false);
  const [isOwner, setOwner] = useState(false);
  const [isAdmin, setAdmin] = useState(false);
  const [isEcom, setEcom] = useState(false);
  const [isConfirmDisabled, setConfirmDisabled] = useState(true);
  let t3;
  if ($[6] !== state?.accounts || $[7] !== state?.activeAccount?.sourceSystems) {
    t3 = () => {
      if (process.env.NEXT_PUBLIC_AXP_ENABLED === "true" && state?.accounts && state?.accounts?.length > 0) {
        const isOwner_0 = state?.accounts?.find(_temp);
        const isAdmin_0 = state?.accounts?.find(_temp2);
        if (isOwner_0?.role) {
          localStorage.setItem("id_link", isOwner_0?.id);
          setOwner(true);
        }
        if (isAdmin_0?.role) {
          localStorage.setItem("id_link", isOwner_0?.id);
          setAdmin(true);
        }
        const isEcommerce = state?.accounts?.find(_temp3);
        if (state?.activeAccount?.sourceSystems?.includes("TDX")) {
          setDx(true);
        } else {
          setDx(false);
        }
        if (isEcommerce) {
          setEcom(true);
        }
      }
    };
    $[6] = state?.accounts;
    $[7] = state?.activeAccount?.sourceSystems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = state?.activeAccount;
  const t5 = state?.accounts;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = [t4, t5];
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useEffect(t3, t6);
  let t7;
  if ($[12] !== state?.activeAccount?.role) {
    t7 = () => {
      if (state?.activeAccount?.role?.includes("OWNER")) {
        setOwnerAccount(true);
        setAdminAccount(false);
      }
      if (state?.activeAccount?.role?.includes("ADMIN")) {
        setOwnerAccount(false);
        setAdminAccount(true);
      }
      if (state?.activeAccount?.role?.includes("USER")) {
        setOwnerAccount(false);
        setAdminAccount(false);
      }
    };
    $[12] = state?.activeAccount?.role;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = state?.activeAccount;
  let t9;
  if ($[14] !== t8) {
    t9 = [t8];
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  useEffect(t7, t9);
  let links;
  if (process.env.NEXT_PUBLIC_AXP_ENABLED) {
    if (isDx && isOwnerAccount && localStorage?.getItem("id_link")) {
      const t10 = flyoutData?.profileLabel || "My Profile";
      let t11;
      if ($[16] !== t10) {
        t11 = {
          url: `${myProfileBaseUrl}/`,
          text: t10
        };
        $[16] = t10;
        $[17] = t11;
      } else {
        t11 = $[17];
      }
      const t12 = flyoutData?.myProductsLabel || "My Products";
      let t13;
      if ($[18] !== t12) {
        t13 = {
          url: accountsBaseUrl,
          text: t12
        };
        $[18] = t12;
        $[19] = t13;
      } else {
        t13 = $[19];
      }
      const t14 = flyoutData?.supportLabel || "Support";
      let t15;
      if ($[20] !== t14) {
        t15 = {
          url: process.env.NEXT_PUBLIC_SUPPORT_LINK,
          text: t14
        };
        $[20] = t14;
        $[21] = t15;
      } else {
        t15 = $[21];
      }
      let t16;
      if ($[22] !== state) {
        t16 = env === "stage" ? `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/subscriptions` : `${accountsBaseUrl}/${localStorage.getItem("id_link")}/subscriptions`;
        $[22] = state;
        $[23] = t16;
      } else {
        t16 = $[23];
      }
      const t17 = flyoutData?.manageAccountsLabel || "Manage Accounts";
      let t18;
      if ($[24] !== t16 || $[25] !== t17) {
        t18 = {
          url: t16,
          text: t17
        };
        $[24] = t16;
        $[25] = t17;
        $[26] = t18;
      } else {
        t18 = $[26];
      }
      let t19;
      if ($[27] !== t11 || $[28] !== t13 || $[29] !== t15 || $[30] !== t18) {
        t19 = [t11, t13, t15, t18];
        $[27] = t11;
        $[28] = t13;
        $[29] = t15;
        $[30] = t18;
        $[31] = t19;
      } else {
        t19 = $[31];
      }
      links = t19;
    } else {
      if (isDx && !isOwnerAccount) {
        const t10 = flyoutData?.profileLabel || "My Profile";
        let t11;
        if ($[32] !== t10) {
          t11 = {
            url: `${myProfileBaseUrl}/`,
            text: t10
          };
          $[32] = t10;
          $[33] = t11;
        } else {
          t11 = $[33];
        }
        const t12 = flyoutData?.myProductsLabel || "My Products";
        let t13;
        if ($[34] !== t12) {
          t13 = {
            url: productsLink,
            text: t12
          };
          $[34] = t12;
          $[35] = t13;
        } else {
          t13 = $[35];
        }
        const t14 = flyoutData?.supportLabel || "Support";
        let t15;
        if ($[36] !== t14) {
          t15 = {
            url: process.env.NEXT_PUBLIC_SUPPORT_LINK,
            text: t14
          };
          $[36] = t14;
          $[37] = t15;
        } else {
          t15 = $[37];
        }
        let t16;
        if ($[38] !== t11 || $[39] !== t13 || $[40] !== t15) {
          t16 = [t11, t13, t15];
          $[38] = t11;
          $[39] = t13;
          $[40] = t15;
          $[41] = t16;
        } else {
          t16 = $[41];
        }
        links = t16;
      } else {
        const t10 = flyoutData?.profileLabel || "My Profile";
        let t11;
        if ($[42] !== t10) {
          t11 = {
            url: `${myProfileBaseUrl}/`,
            text: t10
          };
          $[42] = t10;
          $[43] = t11;
        } else {
          t11 = $[43];
        }
        const t12 = flyoutData?.myProductsLabel || "My Products";
        let t13;
        if ($[44] !== t12) {
          t13 = {
            url: productsLink,
            text: t12
          };
          $[44] = t12;
          $[45] = t13;
        } else {
          t13 = $[45];
        }
        let t14;
        if ($[46] !== t11 || $[47] !== t13) {
          t14 = [t11, t13];
          $[46] = t11;
          $[47] = t13;
          $[48] = t14;
        } else {
          t14 = $[48];
        }
        links = t14;
      }
    }
  }
  if (!process.env.NEXT_PUBLIC_AXP_ENABLED) {
    const t10 = flyoutData?.profileLabel || "My Profile";
    let t11;
    if ($[49] !== t10) {
      t11 = {
        url: `${myProfileBaseUrl}/`,
        text: t10
      };
      $[49] = t10;
      $[50] = t11;
    } else {
      t11 = $[50];
    }
    const t12 = flyoutData?.myProductsLabel || "My Products";
    let t13;
    if ($[51] !== t12) {
      t13 = {
        url: productsLink,
        text: t12
      };
      $[51] = t12;
      $[52] = t13;
    } else {
      t13 = $[52];
    }
    let t14;
    if ($[53] !== t11 || $[54] !== t13) {
      t14 = [t11, t13];
      $[53] = t11;
      $[54] = t13;
      $[55] = t14;
    } else {
      t14 = $[55];
    }
    links = t14;
  }
  let t10;
  if ($[56] !== flyoutData?.accountOwner || $[57] !== flyoutData?.licenseAdmin || $[58] !== flyoutData?.productUser || $[59] !== flyoutData?.secondaryAccountOwner || $[60] !== state?.accountId || $[61] !== state?.accounts || $[62] !== state?.isAccountConfirmationRequired || $[63] !== state?.isEcommercePage) {
    t10 = () => {
      const roleMapper = role => {
        if (!role) {
          return "";
        }
        if (role === "ACCOUNT_OWNER") {
          return flyoutData?.accountOwner || "Account Owner";
        }
        if (role === "SECONDARY_ACCOUNT_OWNER") {
          return flyoutData?.secondaryAccountOwner || "Secondary Account Owner";
        }
        if (role === "COMPANY_ADMIN") {
          return flyoutData?.licenseAdmin || "License Admin";
        }
        if (role === "PRODUCT_USER") {
          return flyoutData?.productUser || "Product User";
        }
        return role;
      };
      const flyoutAccounts_0 = state?.accounts?.map(account_2 => {
        const isPurchasingAccount = account_2?.role === "ACCOUNT_OWNER" || account_2?.role === "SECONDARY_ACCOUNT_OWNER";
        return {
          ...account_2,
          isDisabled: (state?.isEcommercePage || state?.isAccountConfirmationRequired) && !isPurchasingAccount,
          formattedRole: roleMapper(account_2?.role)
        };
      });
      const isAccountDisabled = flyoutAccounts_0?.find(d => d.id === state?.accountId)?.isDisabled;
      setConfirmDisabled(isAccountDisabled);
      setFlyoutAccounts(flyoutAccounts_0);
    };
    $[56] = flyoutData?.accountOwner;
    $[57] = flyoutData?.licenseAdmin;
    $[58] = flyoutData?.productUser;
    $[59] = flyoutData?.secondaryAccountOwner;
    $[60] = state?.accountId;
    $[61] = state?.accounts;
    $[62] = state?.isAccountConfirmationRequired;
    $[63] = state?.isEcommercePage;
    $[64] = t10;
  } else {
    t10 = $[64];
  }
  const t11 = state?.isEcommercePage;
  const t12 = state?.isAccountConfirmationRequired;
  const t13 = state?.accounts;
  const t14 = state?.accountId;
  let t15;
  if ($[65] !== flyoutData || $[66] !== t11 || $[67] !== t12 || $[68] !== t13 || $[69] !== t14) {
    t15 = [t11, t12, t13, t14, flyoutData];
    $[65] = flyoutData;
    $[66] = t11;
    $[67] = t12;
    $[68] = t13;
    $[69] = t14;
    $[70] = t15;
  } else {
    t15 = $[70];
  }
  useEffect(t10, t15);
  let t16;
  if ($[71] !== dispatch || $[72] !== state?.isAccountChangeRequested) {
    t16 = () => {
      if (state?.isAccountChangeRequested) {
        setAccountSwitcherOpen(true);
        dispatch({
          type: "SET_ACCOUNT_CHANGE_REQUESTED",
          payload: false
        });
      }
    };
    $[71] = dispatch;
    $[72] = state?.isAccountChangeRequested;
    $[73] = t16;
  } else {
    t16 = $[73];
  }
  const t17 = state?.isAccountChangeRequested;
  let t18;
  if ($[74] !== dispatch || $[75] !== t17) {
    t18 = [t17, dispatch];
    $[74] = dispatch;
    $[75] = t17;
    $[76] = t18;
  } else {
    t18 = $[76];
  }
  useEffect(t16, t18);
  let t19;
  if ($[77] !== state?.accounts || $[78] !== state?.isAccountConfirmationRequired) {
    t19 = () => {
      if (state?.isAccountConfirmationRequired && state?.accounts && state?.accounts?.length > 0) {
        setAccountSwitcherOpen(true);
      }
    };
    $[77] = state?.accounts;
    $[78] = state?.isAccountConfirmationRequired;
    $[79] = t19;
  } else {
    t19 = $[79];
  }
  const t20 = state?.isAccountConfirmationRequired;
  const t21 = state?.accounts;
  let t22;
  if ($[80] !== t20 || $[81] !== t21) {
    t22 = [t20, t21];
    $[80] = t20;
    $[81] = t21;
    $[82] = t22;
  } else {
    t22 = $[82];
  }
  useEffect(t19, t22);
  let t23;
  if ($[83] !== client_id || $[84] !== code_verifier || $[85] !== dispatch || $[86] !== isAuthenticated || $[87] !== loginState?.refreshToken || $[88] !== loginState?.token || $[89] !== onLogin || $[90] !== onLogout || $[91] !== path || $[92] !== redirect_uri) {
    t23 = () => {
      const getAccounts = freshAccessToken => {
        dispatch({
          type: "SET_ACCOUNTS_LOADING",
          payload: true
        });
        const url_0 = `${accountsEndpoint}/accounts`;
        const bearer = freshAccessToken ?? loginState?.token;
        fetch(url_0, {
          headers: {
            Authorization: `Bearer ${bearer}`
          }
        }).then(_temp4).then(accountData => {
          dispatch({
            type: "SET_ACCOUNTS_LOADING",
            payload: false
          });
          if (accountData?.statusCode === 401) {
            refreshAuthToken(loginState?.refreshToken ?? null, client_id, redirect_uri, code_verifier, path, null, null, getAccounts, null, onLogin, onLogout);
          }
          if (accountData) {
            dispatch({
              type: "SET_ACCOUNTS",
              payload: accountData
            });
            if (accountData?.length > 0) {
              const sortedAccounts = accountData.toSorted(_temp5);
              const defaultAcct = accountData?.find(_temp6);
              dispatch({
                type: "SET_ACCOUNT_ID",
                payload: defaultAcct?.id ? defaultAcct?.id : sortedAccounts[0]?.id
              });
              dispatch({
                type: "SET_ACTIVE_ACCOUNT",
                payload: defaultAcct?.id ? {
                  ...defaultAcct,
                  default: true
                } : sortedAccounts[0]
              });
            }
            return accountData;
          }
        }).catch(error => {
          dispatch({
            type: "SET_ACCOUNTS_LOADING",
            payload: false
          });
          console.log(error);
        });
      };
      if (process.env.NEXT_PUBLIC_AXP_ENABLED === "true" && process.env.NEXT_PUBLIC_ECOMM_ENABLED !== "true" && isAuthenticated) {
        getAccounts();
      }
    };
    $[83] = client_id;
    $[84] = code_verifier;
    $[85] = dispatch;
    $[86] = isAuthenticated;
    $[87] = loginState?.refreshToken;
    $[88] = loginState?.token;
    $[89] = onLogin;
    $[90] = onLogout;
    $[91] = path;
    $[92] = redirect_uri;
    $[93] = t23;
  } else {
    t23 = $[93];
  }
  const t24 = loginState?.token;
  const t25 = loginState?.refreshToken;
  let t26;
  if ($[94] !== client_id || $[95] !== code_verifier || $[96] !== dispatch || $[97] !== isAuthenticated || $[98] !== onLogin || $[99] !== onLogout || $[100] !== path || $[101] !== redirect_uri || $[102] !== t24 || $[103] !== t25) {
    t26 = [isAuthenticated, dispatch, client_id, redirect_uri, code_verifier, path, onLogin, onLogout, t24, t25];
    $[94] = client_id;
    $[95] = code_verifier;
    $[96] = dispatch;
    $[97] = isAuthenticated;
    $[98] = onLogin;
    $[99] = onLogout;
    $[100] = path;
    $[101] = redirect_uri;
    $[102] = t24;
    $[103] = t25;
    $[104] = t26;
  } else {
    t26 = $[104];
  }
  useEffect(t23, t26);
  let t27;
  if ($[105] !== flyoutAccounts) {
    t27 = accountId => {
      const isDisabled = flyoutAccounts?.find(d_0 => accountId === d_0?.id)?.isDisabled;
      setConfirmDisabled(isDisabled);
    };
    $[105] = flyoutAccounts;
    $[106] = t27;
  } else {
    t27 = $[106];
  }
  const handleAccountChange = t27;
  let t28;
  if ($[107] !== dispatch || $[108] !== pathname || $[109] !== router || $[110] !== state?.accountId || $[111] !== state?.accounts) {
    t28 = accountId_0 => {
      if (accountId_0 !== state?.accountId) {
        const currentParams = new URLSearchParams(window.location.search);
        if (currentParams.has("account")) {
          currentParams.delete("account");
          router.replace(`${pathname}?${currentParams.toString()}`);
        }
        localStorage.removeItem("currency");
        localStorage.removeItem("country");
        sessionStorage.removeItem("alertDismissed");
        const account_4 = state?.accounts?.find(d_1 => accountId_0 === d_1?.id);
        dispatch({
          type: "SET_ACCOUNT_ID",
          payload: accountId_0
        });
        dispatch({
          type: "SET_ACTIVE_ACCOUNT",
          payload: account_4
        });
        if (account_4?.address?.country) {
          localStorage.setItem("country", account_4?.address?.country);
        }
        sessionStorage.setItem("accountId", accountId_0);
      }
      dispatch({
        type: "SET_ACCOUNT_CONFIRMATION_REQUIRED",
        payload: false
      });
      dispatch({
        type: "SET_ACCOUNT_CONFIRMED",
        payload: true
      });
      return true;
    };
    $[107] = dispatch;
    $[108] = pathname;
    $[109] = router;
    $[110] = state?.accountId;
    $[111] = state?.accounts;
    $[112] = t28;
  } else {
    t28 = $[112];
  }
  const handleSubmit = t28;
  let setAccountAsDefault;
  if ($[113] !== client_id || $[114] !== code_verifier || $[115] !== dispatch || $[116] !== loginState?.refreshToken || $[117] !== loginState?.token || $[118] !== onLogin || $[119] !== onLogout || $[120] !== redirect_uri || $[121] !== state?.accounts) {
    setAccountAsDefault = (accountId_1, freshAccessToken_0) => {
      const bearer_0 = freshAccessToken_0 ?? loginState?.token;
      fetch(`${accountsEndpoint}/accounts/set-default-account`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "x-account-id": accountId_1,
          Authorization: `Bearer ${bearer_0}`
        }
      }).then(_temp7).then(result => {
        if (result?.statusCode && result?.statusCode === 401) {
          refreshAuthToken(loginState?.refreshToken ?? null, client_id, redirect_uri, code_verifier, null, null, null, newToken => setAccountAsDefault(accountId_1, newToken), null, onLogin, onLogout);
        }
        if (result?.status === "success") {
          const accounts = state?.accounts.map(account_5 => {
            if (accountId_1 === account_5?.id) {
              return {
                ...account_5,
                isDefaultAccount: true
              };
            }
            return {
              ...account_5,
              isDefaultAccount: false
            };
          });
          dispatch({
            type: "SET_ACCOUNTS",
            payload: accounts
          });
          const accountData_0 = accounts?.find(d_2 => accountId_1 === d_2?.id);
          dispatch({
            type: "SET_ACCOUNT_ID",
            payload: accountData_0?.id
          });
          dispatch({
            type: "SET_ACTIVE_ACCOUNT",
            payload: accountData_0
          });
        }
        return result;
      }).catch(_temp8);
    };
    $[113] = client_id;
    $[114] = code_verifier;
    $[115] = dispatch;
    $[116] = loginState?.refreshToken;
    $[117] = loginState?.token;
    $[118] = onLogin;
    $[119] = onLogout;
    $[120] = redirect_uri;
    $[121] = state?.accounts;
    $[122] = setAccountAsDefault;
  } else {
    setAccountAsDefault = $[122];
  }
  let t29;
  if ($[123] !== state?.accounts) {
    t29 = Array.isArray(state?.accounts) && state?.accounts?.length > 0 ? state?.accounts?.filter(_temp9) : [];
    $[123] = state?.accounts;
    $[124] = t29;
  } else {
    t29 = $[124];
  }
  const purchasableAccounts = t29;
  const t30 = !isLoginDisabled;
  const t31 = flyoutData?.trimbleLogo?.image?.url;
  const t32 = flyoutData?.trimbleLogo?.altText;
  const t33 = `/${locale}/`;
  let t34;
  if ($[125] !== t33) {
    t34 = {
      url: t33
    };
    $[125] = t33;
    $[126] = t34;
  } else {
    t34 = $[126];
  }
  let t35;
  if ($[127] !== t31 || $[128] !== t32 || $[129] !== t34) {
    t35 = {
      url: t31,
      altText: t32,
      link: t34
    };
    $[127] = t31;
    $[128] = t32;
    $[129] = t34;
    $[130] = t35;
  } else {
    t35 = $[130];
  }
  const t36 = flyoutData?.createAccountLabel;
  let t37;
  if ($[131] !== isLoginDisabled || $[132] !== path || $[133] !== signUpQuery) {
    t37 = !isLoginDisabled && typeof window !== "undefined" ? () => window.open(`${signUpQuery}${path}`, "_self") : _temp10;
    $[131] = isLoginDisabled;
    $[132] = path;
    $[133] = signUpQuery;
    $[134] = t37;
  } else {
    t37 = $[134];
  }
  let t38;
  if ($[135] !== t36 || $[136] !== t37) {
    t38 = {
      text: t36,
      signInBtnMethod: t37
    };
    $[135] = t36;
    $[136] = t37;
    $[137] = t38;
  } else {
    t38 = $[137];
  }
  const t39 = flyoutData?.signInLabel;
  let t40;
  if ($[138] !== path || $[139] !== query) {
    t40 = () => window.open(`${query}${path}`, "_self");
    $[138] = path;
    $[139] = query;
    $[140] = t40;
  } else {
    t40 = $[140];
  }
  const t41 = state?.activeAccount && state?.activeAccount?.name !== user?.email ? state?.activeAccount?.name : user ? `${user?.firstName} ${user?.lastName}` : null;
  const t42 = user?.email;
  const t43 = state?.activeAccount?.role;
  const t44 = state?.activeAccount?.organization;
  let t45;
  if ($[141] !== t41 || $[142] !== t42 || $[143] !== t43 || $[144] !== t44) {
    t45 = {
      image: null,
      name: t41,
      email: t42,
      role: t43,
      organization: t44
    };
    $[141] = t41;
    $[142] = t42;
    $[143] = t43;
    $[144] = t44;
    $[145] = t45;
  } else {
    t45 = $[145];
  }
  const t46 = flyoutData?.accountsHeading;
  let t47;
  if ($[146] !== links || $[147] !== t46) {
    t47 = {
      title: t46,
      links
    };
    $[146] = links;
    $[147] = t46;
    $[148] = t47;
  } else {
    t47 = $[148];
  }
  const t48 = flyoutData?.marketingHeading;
  let t49;
  if ($[149] !== flyoutData?.linksCollection?.items) {
    t49 = flyoutData?.linksCollection?.items?.map(_temp11);
    $[149] = flyoutData?.linksCollection?.items;
    $[150] = t49;
  } else {
    t49 = $[150];
  }
  let t50;
  if ($[151] !== t48 || $[152] !== t49) {
    t50 = {
      title: t48,
      links: t49
    };
    $[151] = t48;
    $[152] = t49;
    $[153] = t50;
  } else {
    t50 = $[153];
  }
  const t51 = flyoutData?.showCustomLinks;
  const t52 = flyoutData?.customLinksHeading;
  let t53;
  if ($[154] !== flyoutData?.customLinksCollection?.items) {
    t53 = flyoutData?.customLinksCollection?.items?.map(_temp12);
    $[154] = flyoutData?.customLinksCollection?.items;
    $[155] = t53;
  } else {
    t53 = $[155];
  }
  let t54;
  if ($[156] !== t51 || $[157] !== t52 || $[158] !== t53) {
    t54 = {
      enabled: t51,
      title: t52,
      links: t53
    };
    $[156] = t51;
    $[157] = t52;
    $[158] = t53;
    $[159] = t54;
  } else {
    t54 = $[159];
  }
  let t55;
  if ($[160] !== flyoutData?.legalLinksCollection?.items) {
    t55 = flyoutData?.legalLinksCollection?.items?.map(_temp13);
    $[160] = flyoutData?.legalLinksCollection?.items;
    $[161] = t55;
  } else {
    t55 = $[161];
  }
  let t56;
  if ($[162] !== t55) {
    t56 = {
      links: t55
    };
    $[162] = t55;
    $[163] = t56;
  } else {
    t56 = $[163];
  }
  const t57 = !state?.isEcommercePage || state?.isEcommercePage && purchasableAccounts?.length > 1;
  const t58 = state?.isAccountsLoading;
  const t59 = flyoutData?.loadingLabel || "Loading...";
  const t60 = flyoutData?.adminConsoleLabel || "Admin Console";
  const t61 = state?.accountId;
  const t62 = flyoutData?.selectButtonLabel || "Select";
  const t63 = flyoutData?.defaultLabel || "Default";
  const t64 = flyoutData?.setAsDefaultLabel || "Set as default";
  const t65 = flyoutData?.accountConfirmationText || "Select and confirm your account to proceed. Disabled accounts are not permitted to make purchases.";
  const t66 = state?.isEcommercePage;
  const t67 = state?.isEcommercePage || state?.isAccountConfirmationRequired;
  const t68 = flyoutData?.confirmAccountLabel || "Confirm";
  const t69 = flyoutData?.cancelAccountLabel || "Cancel";
  let t70;
  if ($[164] !== flyoutData?.accountSettings || $[165] !== flyoutData?.manageSubscriptions || $[166] !== flyoutData?.manageUsers || $[167] !== isAdminAccount || $[168] !== isDx || $[169] !== isOwnerAccount || $[170] !== state) {
    t70 = process.env.NEXT_PUBLIC_AXP_ADMIN_CONSOLE === "true" ? isDx && isOwnerAccount ? [{
      url: `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/settings`,
      text: flyoutData?.accountSettings || "Account Settings"
    }, {
      url: `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/subscriptions`,
      text: flyoutData?.manageSubscriptions || "Manage Subscriptions"
    }, {
      url: `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/users`,
      text: flyoutData?.manageUsers || "Manage Users"
    }] : isDx && isAdminAccount ? [{
      url: `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/subscriptions`,
      text: flyoutData?.manageSubscriptions || "Manage Subscriptions"
    }, {
      url: `${accountsBaseUrl}/${localStorage.getItem("id_link") !== state?.acccountId ? state.accountId : localStorage.getItem("id_link")}/users`,
      text: flyoutData?.manageUsers || "Manage Users"
    }] : [] : [];
    $[164] = flyoutData?.accountSettings;
    $[165] = flyoutData?.manageSubscriptions;
    $[166] = flyoutData?.manageUsers;
    $[167] = isAdminAccount;
    $[168] = isDx;
    $[169] = isOwnerAccount;
    $[170] = state;
    $[171] = t70;
  } else {
    t70 = $[171];
  }
  const t71 = isOwner || isAdmin || isEcom;
  let t72;
  if ($[172] !== flyoutAccounts || $[173] !== handleAccountChange || $[174] !== handleSubmit || $[175] !== isAccountSwitcherOpen || $[176] !== isConfirmDisabled || $[177] !== setAccountAsDefault || $[178] !== t57 || $[179] !== t58 || $[180] !== t59 || $[181] !== t60 || $[182] !== t61 || $[183] !== t62 || $[184] !== t63 || $[185] !== t64 || $[186] !== t65 || $[187] !== t66 || $[188] !== t67 || $[189] !== t68 || $[190] !== t69 || $[191] !== t70 || $[192] !== t71) {
    t72 = {
      isEnabled: t57,
      isLoading: t58,
      loadingLabel: t59,
      title: t60,
      accountId: t61,
      accounts: flyoutAccounts,
      isOpen: isAccountSwitcherOpen,
      setOpen: setAccountSwitcherOpen,
      onChange: handleAccountChange,
      selectLabel: t62,
      defaultLabel: t63,
      setAsDefaultLabel: t64,
      updateDefaultAccount: setAccountAsDefault,
      accountConfirmationText: t65,
      isAccountResticted: t66,
      isAccountConfirmationRequired: t67,
      confirmAccountLabel: t68,
      cancelAccountLabel: t69,
      isConfirmDisabled,
      onSubmit: handleSubmit,
      links: t70,
      hasAdminPrivileges: t71
    };
    $[172] = flyoutAccounts;
    $[173] = handleAccountChange;
    $[174] = handleSubmit;
    $[175] = isAccountSwitcherOpen;
    $[176] = isConfirmDisabled;
    $[177] = setAccountAsDefault;
    $[178] = t57;
    $[179] = t58;
    $[180] = t59;
    $[181] = t60;
    $[182] = t61;
    $[183] = t62;
    $[184] = t63;
    $[185] = t64;
    $[186] = t65;
    $[187] = t66;
    $[188] = t67;
    $[189] = t68;
    $[190] = t69;
    $[191] = t70;
    $[192] = t71;
    $[193] = t72;
  } else {
    t72 = $[193];
  }
  let t73;
  if ($[194] !== handleLogout || $[195] !== isAuthenticated || $[196] !== t30 || $[197] !== t35 || $[198] !== t38 || $[199] !== t39 || $[200] !== t40 || $[201] !== t45 || $[202] !== t47 || $[203] !== t50 || $[204] !== t54 || $[205] !== t56 || $[206] !== t72) {
    t73 = {
      oldVersion: false,
      login: t30,
      authenticated: isAuthenticated,
      disableSearch: true,
      logo: t35,
      createAccount: t38,
      signInLabel: t39,
      signInBtnMethod: t40,
      signOutBtnMethod: handleLogout,
      profile: t45,
      myAccountLinks: t47,
      marketingLinks: t50,
      customLinks: t54,
      legalLinks: t56,
      accountSwitcher: t72
    };
    $[194] = handleLogout;
    $[195] = isAuthenticated;
    $[196] = t30;
    $[197] = t35;
    $[198] = t38;
    $[199] = t39;
    $[200] = t40;
    $[201] = t45;
    $[202] = t47;
    $[203] = t50;
    $[204] = t54;
    $[205] = t56;
    $[206] = t72;
    $[207] = t73;
  } else {
    t73 = $[207];
  }
  return t73;
};
export default useFlyout;
function _temp(account) {
  return account?.role?.includes("OWNER");
}
function _temp2(account_0) {
  return account_0?.role?.includes("ADMIN");
}
function _temp3(account_1) {
  return account_1?.sourceSystems?.includes("DVW");
}
function _temp4(response) {
  return response.json();
}
function _temp5(a, b) {
  if (a?.id < b?.id) {
    return -1;
  }
  if (a?.id > b?.id) {
    return 1;
  }
  return 0;
}
function _temp6(account_3) {
  return account_3?.isDefaultAccount;
}
function _temp7(response_0) {
  return response_0.json();
}
function _temp8(error_0) {
  console.log("error", error_0);
}
function _temp9(account_6) {
  return account_6?.role === "ACCOUNT_OWNER" || account_6?.role === "SECONDARY_ACCOUNT_OWNER";
}
function _temp10() {}
function _temp11(link) {
  return formatLink(link);
}
function _temp12(link_0) {
  return formatLink(link_0);
}
function _temp13(link_1) {
  return formatLink(link_1);
}